import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import Navbar from '../../components/navbar/Navbar'
import StackedTitle from '../../components/form_titles/StackedTitle'
import SelectInput from '../../components/input_fields/SelectInput'
import TextInput from '../../components/input_fields/TextInput'
import TwoInputs from '../../components/input_fields/TwoInputs'
import TextSelectSearch from '../../components/input_fields/seachable/TextSelectSearch'
import InputSelectSearch from '../../components/input_fields/seachable/InputSelectSearch'
import validator from "validator"
import { data } from '../../constants'
import Alert from '../../components/alert/Alert'
import Divider from '../../components/divider/Divider'
import { performAppSubmission } from '../../helpers/AppSubmission'
import { executeQuery } from '../../helpers/Database'

const SimpleEntry = () => {
    const [validation, setValidation] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [userId, setUserId] = useState(-1);
    const [firebaseUserId, setFirebaseUserId] = useState(-1);
    const [userEmail, setUserEmail] = useState("");
    const [alertState, setAlertState] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [scrollToField, setScrollToField] = useState(null);

    const [fnameError, setFnameError] = useState(false);
    const [lnameError, setLnameError] = useState(false);
    const [ownerPhoneError, setOwnerPhoneError] = useState(false);
    const [ownerEmailError, setOwnerEmailError] = useState(false);
    const [princStreetError, setPrincStreetError] = useState(false);
    const [princCityError, setPrincCityError] = useState(false);
    const [princStateError, setPrincStateError] = useState(false);
    const [princZipError, setPrincZipError] = useState(false);
    const [princDOBError, setPrincDOBError] = useState(false);
    const [princSSNError, setPrincSSNError] = useState(false);
    const [busNameError, setBusNameError] = useState(false);
    const [busStreetError, setBusStreetError] = useState(false);
    const [busCityError, setBusCityError] = useState(false);
    const [busStateError, setBusStateError] = useState(false);
    const [busZipError, setBusZipError] = useState(false);
    const [busPhoneError, setBusPhoneError] = useState(false);
    const [mccsccError, setMccsccError] = useState(false);
    const [busDescError, setBusDescError] = useState(false);
    const [whenChargedError, setWhenChargedError] = useState(false);
    const [subsOfferedError, setSubsOfferedError] = useState(false);
    const [deliveryTimeframeError, setDeliveryTimeframeError] = useState(false);
    const [taxIdError, setTaxIdError] = useState(false);
    const [busStartError, setBusStartError] = useState(false);
    const [stateOfIncorpError, setStateOfIncorpError] = useState(false);
    const [taxStatusError, setTaxStatusError] = useState(false);
    const [taxFilingTypeError, setTaxFilingTypeError] = useState(false);
    const [grossSalesError, setGrossSalesError] = useState(false);
    const [highestSaleError, setHighestSaleError] = useState(false);
    const [annualSalesError, setAnnualSalesError] = useState(false);
    const [avgSalesError, setAvgSalesError] = useState(false);
    const [finInstError, setFinInstError] = useState(false);
    const [finPhoneError, setFinPhoneError] = useState(false);
    const [checkingNumError, setCheckingNumError] = useState(false);
    const [bankABAError, setBankABAError] = useState(false);
    const [nameOnAccountError, setNameOnAccountError] = useState(false);

    const [formData, setFormData] = useState({
        ownerFName: "",
        ownerLName: "",
        ownerPhone: "",
        ownerEmail: "",

        princStreet: "",
        princStreet2: "",
        princCity: "",
        princState: "Owner State",
        princZip: "",
        princDOB: "",
        princSSN: "",
        princTitle: "",
        princMainOwner: "",
        princOwnership: "",

        busName: "",
        tradeName: "",
        busStreet: "",
        busStreet2: "",
        busCity: "",
        busState: "Bus State",
        busZip: "",
        busPhone: "",
        busURL: "",

        mcc_Iso: "",
        busDesc: "",
        whenCharged: "",
        subsOffered: "",
        deliveryTimeframe: "",
        grossSales: "",
        highestSale: "",
        annualSales: "",
        avgSales: "",

        taxId: "",
        busStart: "",
        incorpStateCode: "Incorp State",
        taxStatus: "",
        taxFilingType: "",

        finInst: "",
        finPhone: "",
        checkingNum: "",
        bankABA: "",
        nameOnAccount: "",

        authToken: "",
        appResult: "",
        appRef: "",
        appInternalMID: "",
        userId: "",
        firebaseUserId: "",
        userEmail: "",
        test: "false",
    })

    const color = "#F48C06";
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const setAlert = (severity, message) => {
        setAlertState(true);
        setAlertSeverity(severity);
        setAlertMessage(message);
    };

    const clearAlert = () => {
        setAlertState(false);
        setAlertSeverity('');
        setAlertMessage('');
    };

    const isNull = (variable) => {
        return ((variable === null) || (typeof variable === "undefined"));
    }

    const clearValidationErrors = () => {
        setFnameError(false);
        setLnameError(false);
        setOwnerPhoneError(false);
        setOwnerEmailError(false);
        setPrincStreetError(false);
        setPrincCityError(false);
        setPrincStateError(false);
        setPrincZipError(false);
        setPrincDOBError(false);
        setPrincSSNError(false);
        setBusNameError(false);
        setBusStreetError(false);
        setBusCityError(false);
        setBusStateError(false);
        setBusZipError(false);
        setBusPhoneError(false);
        setMccsccError(false);
        setBusDescError(false);
        setWhenChargedError(false);
        setSubsOfferedError(false);
        setDeliveryTimeframeError(false);
        setGrossSalesError(false);
        setHighestSaleError(false);
        setAnnualSalesError(false);
        setAvgSalesError(false);
        setTaxIdError(false);
        setBusStartError(false);
        setStateOfIncorpError(false);
        setTaxFilingTypeError(false);
        setTaxStatusError(false);
        setFinInstError(false);
        setFinPhoneError(false);
        setCheckingNumError(false);
        setBankABAError(false);
        setNameOnAccountError(false);
    }

    const validateFields = () => {
        // if validation is turned OFF return TRUE immediately;
        if (!validation) { return true; }

        if (validation) {
            //Fname Errors
            if (validator.isEmpty(formData.ownerFName)) {
                setFnameError(true);
                setScrollToField("ownerFName");
                return false;
            }

            //Lname Errors
            if (validator.isEmpty(formData.ownerLName)) {
                setLnameError(true);
                setScrollToField("ownerLName");
                return false;
            }

            //Street Address
            if (validator.isEmpty(formData.busStreet)) {
                setBusStreetError(true);
                setScrollToField("busStreet");
                return false;
            }

            //Owner City
            if (validator.isEmpty(formData.princCity)) {
                setPrincCityError(true);
                setScrollToField("princCity");
                return false;
            }

            //Owner State
            if (!data.states.includes(formData.princState)) {
                setPrincStateError(true);
                // InputSelectSearch not working with second component so scroll to princCity
                setScrollToField("princCity");
                return false;
            }

            //Zip
            if (validator.isEmpty(formData.princZip)) {
                setPrincZipError(true);
                setScrollToField("princZip");
                return false;
            }

            // Owner Phone Error
            if (!validator.isMobilePhone(formData.ownerPhone)) {
                setOwnerPhoneError(true);
                setScrollToField("ownerPhone");
                return false;
            }

            // Email Errors
            if (!validator.isEmail(formData.ownerEmail)) {
                setOwnerEmailError(true);
                setScrollToField("ownerEmail");
                return false;
            }

            // Owner Date of Birth Error
            if (!formData.princDOB.match(/(\d{4}(\/|-)\d{1,2}(\/|-)\d{1,2})/)) {
                setPrincDOBError(true);
                setScrollToField("princDOB");
                return false;
            }

            // Owner Social Securiy Number Error
            if (!validator.isNumeric(formData.princSSN) || formData.princSSN.length !== 9) {
                setPrincSSNError(true);
                setScrollToField("princSSN");
                return false;
            }

            // Bussiness Name Errors
            if (!validator.isAlphanumeric(formData.busName, 'en-US', { ignore: ' &-' })) {
                setBusNameError(true);
                setScrollToField("busName");
                return false;
            }

            // Business Street Address
            if (validator.isEmpty(formData.busStreet)) {
                setBusStreetError(true);
                setScrollToField("busStreet");
                return false;
            }

            // Business City
            if (validator.isEmpty(formData.busCity)) {
                setBusCityError(true);
                setScrollToField("busCity");
                return false;
            }

            // Business State
            if (!data.states.includes(formData.busState)) {
                setBusStateError(true);
                // InputSelectSearch not working with second component so scroll to busCity
                setScrollToField("busCity");
                return false;
            }

            // Business Zip
            if (validator.isEmpty(formData.busZip)) {
                setBusZipError(true);
                setScrollToField("busZip");
                return false;
            }

            // Business Phone Errors
            if (!validator.isMobilePhone(formData.busPhone)) {
                setBusPhoneError(true);
                setScrollToField("busPhone");
                return false;
            }

            // MCC/SIC code
            if (formData.mcc_Iso !== "N/A") {
                if (formData.mcc_Iso.length !== 4 || !validator.isNumeric(formData.mcc_Iso)) {
                    setMccsccError(true);
                    setScrollToField("mcc_Iso");
                    return false;
                }
            }

            // Business Description
            if (formData.mcc_Iso === "N/A") {
                if (validator.isEmpty(formData.busDesc)) {
                    setBusDescError(true);
                    setScrollToField("busDesc");
                    return false;
                }
            }

            // When Charged Error
            if (validator.isEmpty(formData.whenCharged)) {
                setWhenChargedError(true);
                setScrollToField("whenCharged");
                return false;
            }

            // Delivery Timeframe Error
            if (validator.isEmpty(formData.deliveryTimeframe)) {
                setDeliveryTimeframeError(true);
                setScrollToField("deliveryTimeframe");
                return false;
            }

            // Subscriptions Offered Error
            if (validator.isEmpty(formData.subsOffered)) {
                setSubsOfferedError(true);
                setScrollToField("subsOffered");
                return false;
            }

            //Gross Sales Error
            if (!validator.isNumeric(formData.grossSales)) {
                setGrossSalesError(true);
                setScrollToField("grossSales");
                return false;
            }

            //Highest Sale Error
            if (!validator.isNumeric(formData.highestSale)) {
                setHighestSaleError(true);
                setScrollToField("highestSale");
                return false;
            }

            //Annual Sales Error
            if (!validator.isNumeric(formData.annualSales)) {
                setAnnualSalesError(true);
                setScrollToField("annualSales");
                return false;
            }

            //Average Sales Error
            if (!validator.isNumeric(formData.avgSales)) {
                setAvgSalesError(true);
                setScrollToField("avgSales");
                return false;
            }

            // Tax Id
            if ((!validator.isNumeric(formData.taxId) || formData.taxId.length !== 9)) {
                setTaxIdError(true);
                setScrollToField("taxId");
                return false;
            }

            // Bus Date Error
            if (!formData.busStart.match(/(\d{4}(\/|-)\d{1,2}(\/|-)\d{1,2})/)) {
                setBusStartError(true);
                setScrollToField("busStart");
                return false;
            }

            // Incorporation State Error
            if (!data.states.includes(formData.incorpStateCode)) {
                setStateOfIncorpError(true);
                setScrollToField("incorpStateCode");
                return false;
            }

            // Tax Status Error
            if (validator.isEmpty(formData.taxStatus)) {
                setTaxStatusError(true);
                setScrollToField("taxStatus");
                return false;
            }

            // Filing Type Error
            if (validator.isEmpty(formData.taxFilingType)) {
                setTaxFilingTypeError(true);
                setScrollToField("taxFilingType");
                return false;
            }

            // Financial Institute Error
            if (validator.isEmpty(formData.finInst)) {
                setFinInstError(true);
                setScrollToField("finInst");
                return false;
            }

            // Financial Phone Error
            if (!validator.isMobilePhone(formData.finPhone)) {
                setFinPhoneError(true);
                setScrollToField("finPhone");
                return false;
            }

            // Financial Checking Error
            if (validator.isEmpty(formData.checkingNum) || formData.checkingNum.length < 6) {
                setCheckingNumError(true);
                setScrollToField("checkingNum");
                return false;
            }

            // Financial ABA Error
            if (!validator.isNumeric(formData.bankABA) || formData.bankABA.length !== 9) {
                setBankABAError(true);
                setScrollToField("bankABA");
                return false;
            }

            // Name on Account Errors
            if (validator.isEmpty(formData.nameOnAccount)) {
                setNameOnAccountError(true);
                setScrollToField("nameOnAccount");
                return false;
            }
        }

        return true;
    }

    const submitFormData = async () => {
        window.scrollTo(0, 0);

        setSubmitting(true);
        setAlert('info', 'Application is being submitted, please wait.');
        clearValidationErrors();

        // do validation
        if (!validateFields()) {
            clearAlert();
            setSubmitting(false);
            return;
        };

        // submit the new application
        try {
            formData.userId = userId;
            formData.firebaseUserId = firebaseUserId;
            formData.userEmail = userEmail;
            // console.log(formData);

            // add the new application
            let response = await performAppSubmission(formData);

            // add record to Pipeline table
            // response = await addRecordToPipeline(formData);

            // navigate to Pipeline page
            navigate('/pipeline');

            // console.log('submitFormData, exit');
        }
        catch (error) {
            console.log(`SimpleEntry, submitFormData - error: ${error.message}`);
            setAlert('error', 'Something went wrong - check your data and try again.');
        }
        finally {
            setSubmitting(false);
        }
    }

    const handleScrollToField = (id) => {
        // console.log(`handleScrollToField, entry. id: ${id}`);
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const handleFormData = input => e => {
        // input value from the form
        let { value } = e.target;
        // console.log(`handleFormData triggered, value: ${value}`);

        if (e.target.type === 'checkbox') {
            value = e.target.checked
        }

        //updating for data state taking previous state and then adding new value to create new object
        setFormData(prevState => ({
            ...prevState,
            [input]: value
        }));
    }

    const getUserId = async (fbId) => {
        // console.log("getUserId, entry");
        let result = -1;
        let response = "";

        const fetchUser = async (qry, prm) => {
            // console.log(`fetching user, prm: ${prm}`);
            return await executeQuery(qry, prm);
        };

        let query = 'SELECT * FROM users WHERE firebase_id = ?';
        let params = [fbId];

        if (!isNull(fbId)) {
            // RESPONSE comes back as an ARRAY!
            response = await fetchUser(query, params);
            result = response[0].id;
        }

        // console.log(`returning result: ${result}`);
        return result;
    }

    const addRecordToPipeline = (formdata) => {
        // console.log("addRecordToPipeline, entry");

        const insertPipeline = async (qry, prm) => {
            const results = await executeQuery(query, params);
            // console.log(results);
        };

        let query = 'INSERT INTO pipeline (user_id, ref_id, internal_mid) VALUES (?,?,?)';
        let params = [formdata.userId, formdata.appRef, formdata.appInternalMID];

        insertPipeline(query, params);
    }

    useEffect(() => {
        if (scrollToField) {
            handleScrollToField(scrollToField);
            setScrollToField(null);
        }
    }, [scrollToField]);

    useEffect(() => {
        window.scrollTo(0, 0);
        clearAlert();

        if ((currentUser) && (userId === -1)) {
            // console.log("useEffect triggered");
            // getUserId(currentUser.uid)
            //     .then(userId => {
            //         setUserId(userId); // This will be the actual number
            //     })
            setFirebaseUserId(currentUser.uid);
            setUserEmail(currentUser.email);

            // console.log(`SimpleEntry, useEffect entry; UserId: ${currentUser.uid}, UserEmail: ${currentUser.email}`);

            // ****** testing only !! **************
            // formData.test = true;
            // setValidation(false);
            // setFormData(data.testAppSubmissionData);
            // *************************************                 
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="App-container-2 min-h-screen">
            <Navbar />
            {alertState && <Alert alertSeverity={alertSeverity}
                alertMessage={alertMessage}
                onClose={() => clearAlert()} />}
            <div className="flex justify-center">
                <div className="bg-white rounded-lg shadow dark:border">
                    <div className="p-6 space-y-1 sm:p-8">
                        <StackedTitle
                            color={`${color}`}
                            mainTitle="Welcome! Let's enter"
                            colorTitle="your merchant information."
                            subText="Enter your merchant account information then press the Submit button below."
                        />
                    </div>
                    <form className="space-y-4 ">
                        <Divider title={"Owner information"} />
                        <TwoInputs
                            color={color}
                            placeholder1="Owner First Name" id1="ownerFName" type1="text" name1="ownerFName" value1={formData.ownerFName}
                            error1={fnameError} message1="Please enter the owner's first name"
                            handleInputChange1={handleFormData}
                            placeholder2="Owner Last Name" id2="ownerLName" type2="text" name2="ownerLName" value2={formData.ownerLName}
                            error2={lnameError} message2="Please enter the owner's last name"
                            handleInputChange2={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Owner Street Address" id1="princStreet" name1="princStreet" type1="text" value1={formData.princStreet}
                            error1={princStreetError} message1={"Please provide a street address."}
                            handleInputChange1={handleFormData}
                            placeholder2="Owner Street Address 2" id2="princStreet2" name2="princStreet2" type2="text" value2={formData.princStreet2}
                            handleInputChange2={handleFormData}
                        />
                        <InputSelectSearch
                            color={color}
                            placeholder1="Owner City" id1="princCity" type1="text" name1="princCity" value1={formData.princCity}
                            error1={princCityError} message1={"Please enter a city."}
                            handleInputChange1={handleFormData}
                            placeholder2="Owner State" id2="princState" type2="text" name2="princState" value2={formData.princState}
                            error2={princStateError} message2={"Please enter a valid State."}
                            handleInputChange2={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Owner Zip Code" id1="princZip" name1="princZip" type1="text" value1={formData.princZip}
                            error1={princZipError} message1={"Please provide owner's 5 digit zipcode."}
                            handleInputChange1={handleFormData}
                            placeholder2="Owner Title" id2="princTitle" name2="princTitle" type2="text" value2={formData.princTitle}
                            handleInputChange2={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Owner Phone Number" id1="ownerPhone" name1="ownerPhone" type1="text" value1={formData.ownerPhone}
                            error1={ownerPhoneError} message1={"Please enter a valid phone number."}
                            handleInputChange1={handleFormData}
                            placeholder2="Owner Email" id2="ownerEmail" name2="ownerEmail" type2="text" value2={formData.ownerEmail}
                            error2={ownerEmailError} message2={"Please enter a valid email."}
                            handleInputChange2={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Owner Date of Birth" id1="princDOB" name1="princDOB" type1="text" value1={formData.princDOB}
                            error1={princDOBError} message1={"Please enter a valid DOB (yyyy-mm-dd)"}
                            handleInputChange1={handleFormData}
                            placeholder2="Social Security Number" id2="princSSN" name2="princSSN" type2="password" value2={formData.princSSN}
                            error2={princSSNError} message2={"Please enter a social security number."}
                            handleInputChange2={handleFormData}
                        />
                        <Divider title={"Business name and location"} />
                        <TwoInputs
                            color={color}
                            placeholder1="Business Name" id1="busName" type1="text" name1="busName" value1={formData.busName}
                            error1={busNameError} message1="Please enter a business name"
                            handleInputChange1={handleFormData}
                            placeholder2="DBA Name" id2="tradeName" type2="text" name2="tradeName" value2={formData.tradeName}
                            handleInputChange2={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Bus Street Address" id1="busStreet" name1="busStreet" type1="text" value1={formData.busStreet}
                            error1={busStreetError} message1={"Please provide a street address."}
                            handleInputChange1={handleFormData}
                            placeholder2="Bus Street Address 2" id2="busStreet2" name2="busStreet2" type2="text" value2={formData.busStreet2}
                            handleInputChange2={handleFormData}
                        />
                        <InputSelectSearch
                            color={color}
                            placeholder1="Bus City" id1="busCity" type1="text" name1="busCity" value1={formData.busCity}
                            error1={busCityError} message1={"Please enter a city."}
                            handleInputChange1={handleFormData}
                            placeholder2="Bus State" id2="busState" type2="text" name2="busState" value2={formData.busState}
                            error2={busStateError} message2={"Please enter a valid State."}
                            handleInputChange2={handleFormData}
                        />

                        <TextInput
                            color={color}
                            placeholder="Bus Zip Code" id="busZip" name="busZip" type="text" value={formData.busZip}
                            error={busZipError} message={"Please provide a 5 digit zipcode."}
                            handleInputChange={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Bus Phone Number" id1="busPhone" name1="busPhone" type1="text" value1={formData.busPhone}
                            error1={busPhoneError} message1={"Please enter a valid phone number."}
                            handleInputChange1={handleFormData}
                            placeholder2="Bus URL" id2="busURL" name2="busURL" type2="text" value2={formData.busURL}
                            handleInputChange2={handleFormData}
                        />
                        <Divider title={"Tell us about the business"} />
                        <TwoInputs
                            color={color}
                            placeholder1="MCC/SIC Code (4 digits)" id1="mcc_Iso" name1="mcc_Iso" type1="text" value1={formData.mcc_Iso}
                            error1={mccsccError} message1={'Must be four digits. (Type "N/A" if you don\'t know it.)'}
                            handleInputChange1={handleFormData}
                            placeholder2="Business primarily deals in..." id2="busDesc" name2="busDesc" type2="text" value2={formData.busDesc}
                            error2={busDescError} message2={"Please provide a short description of the business."}
                            handleInputChange2={handleFormData}
                        />
                        <SelectInput
                            color={color}
                            placeholder="Select when the customer charged" id="whenCharged" name="whenCharged"
                            options={["One time before service delivery", "One time after service deliver", "Other"]}
                            value={formData.whenCharged}
                            error={whenChargedError} message={"Please select when the customer is charged."}
                            handleInputChange={handleFormData}
                        />
                        <SelectInput
                            color={color}
                            placeholder="Select deliver timeframe" id="deliveryTimeframe" name="deliveryTimeframe"
                            options={["Instantly", "1-7 Days", "8-14 Days", "15-30 Days", "Greater than 30 Days"]}
                            value={formData.deliveryTimeframe}
                            error={deliveryTimeframeError} message={"Please select delivery timeframe."}
                            handleInputChange={handleFormData}
                        />
                        <SelectInput
                            color={color}
                            placeholder="Are subscriptions offered" id="subsOffered" name="subsOffered"
                            options={["Yes", "No"]}
                            value={formData.subsOffered}
                            error={subsOfferedError} message={"Please select if suscriptions are offered."}
                            handleInputChange={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Total Annual Sales (Gross)" id1="grossSales" name1="grossSales" type1="number" value1={formData.grossSales}
                            error1={grossSalesError} message1={"Please input a valid number."}
                            handleInputChange1={handleFormData}
                            placeholder2="Highest Credit Card Sale" id2="highestSale" name2="highestSale" type2="number" value2={formData.highestSale}
                            error2={highestSaleError} message2={"Please input a valid number."}
                            handleInputChange2={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Annual Credit Card Sales" id1="annualSales" name1="annualSales" type1="number" value1={formData.annualSales}
                            error1={annualSalesError} message1={"Please input a valid number."}
                            handleInputChange1={handleFormData}
                            placeholder2="AVG. Credit Card Sale Amount" id2="avgSales" name2="avgSales" type2="number" value2={formData.avgSales}
                            error2={avgSalesError} message2={"Please input a valid number."}
                            handleInputChange2={handleFormData}
                        />
                        <TextInput
                            color={color}
                            placeholder="Federal Tax ID Number" id="taxId" name="taxId" type="password" value={formData.taxId}
                            error={taxIdError} message={"Please enter a valid tax ID number."}
                            handleInputChange={handleFormData}
                        />
                        <TextInput
                            color={color}
                            placeholder="Date Business Started (yyyy-mm-dd)" id="busStart" name="busStart" type="text" value={formData.busStart}
                            error={busStartError} message={"Please enter a valid start date (yyyy-mm-dd)"}
                            handleInputChange={handleFormData}
                        />
                        <TextSelectSearch
                            color={color}
                            placeholder1="Incorporation State" id1="incorpStateCode" name1="incorpStateCode" type1="text" value1={formData.incorpStateCode}
                            error1={stateOfIncorpError} message1={"Please enter a valid state."}
                            handleInputChange1={handleFormData}
                            placeholder2="IRS Filing Status" id2="taxStatus" name2="taxStatus" options={["Tax Exempt", "Not Tax Exempt"]} value2={formData.taxStatus}
                            error2={taxStatusError} message2={"Please choose a tax status."}
                            handleInputChange2={handleFormData}
                        />
                        <SelectInput
                            color={color}
                            placeholder="Tax Filing Type" id="taxFilingType" name="taxFilingType"
                            options={["Sole Proprietor", "LLC", "Partnership", "Private Corp", "Public Corp", "Association/Estate/Trust", "Government"]}
                            value={formData.taxFilingType}
                            error={taxFilingTypeError} message={"Please choose a filing type."}
                            handleInputChange={handleFormData}
                        />
                        <Divider title={"Banking information"} />
                        <TwoInputs
                            color={color}
                            placeholder1="Financial Institution" id1="finInst" name1="finInst" type1="text" value1={formData.finInst}
                            error1={finInstError} message1={"Please provide a financial institution."}
                            handleInputChange1={handleFormData}
                            placeholder2="Fin. Inst. Phone Number" id2="finPhone" name2="finPhone" type2="text" value2={formData.finPhone}
                            error2={finPhoneError} message2={"Please enter a valid phone number."}
                            handleInputChange2={handleFormData}
                        />
                        <TwoInputs
                            color={color}
                            placeholder1="Checking Account Number" id1="checkingNum" name1="checkingNum" type1="text" value1={formData.checkingNum}
                            error1={checkingNumError} message1={"Please enter a checking account number that is at least 6 characters long."}
                            handleInputChange1={handleFormData}
                            placeholder2="Bank ABA Routing Number" id2="bankABA" name2="bankABA" type2="text" value2={formData.bankABA}
                            error2={bankABAError} message2={"Please enter a 9 digit routing number."}
                            handleInputChange2={handleFormData}
                        />
                        <TextInput
                            color={color}
                            placeholder="Name on account" id="nameOnAccount" name="nameOnAccount" type="text" value={formData.nameOnAccount}
                            error={nameOnAccountError} message={"Please set name on account."}
                            handleInputChange={handleFormData}
                        />
                    </form>
                </div>
            </div>
            <div className="w-full flex justify-center mb-4 mt-4 gap-8">
                <button
                    className='border rounded-md border-blue-500
                    bg-main-purple hover:bg-primary-300 
                    p-4 my-2 text-center text-white text-base'
                    type='submit'
                    disabled={submitting}
                    onClick={() => submitFormData()}
                >
                    Submit
                </button>
                <button
                    className='border rounded-md border-blue-500
                    bg-main-purple hover:bg-primary-300 
                    p-4 my-2 text-center text-white text-base'
                    onClick={() => navigate(-1)}
                >
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default SimpleEntry
